import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  useGetAssignmentByVideoIdQuery,
  useGetAssignmentMarksByStudentIdQuery,
} from "../../../features/assignment/assignmentApi";
import {
  useGetQuizMarksByIdQuery,
  useGetQuizzesByVideoIdQuery,
} from "../../../features/quiz/quizApi";
import useCheckAssignmentSubmission from "../../../hooks/useCheckAssignmentSubmission";
import { formatDate } from "../../../utils/formatDate";
import { isQuizTaken } from "../../../utils/isQuizTaken";

const Description = ({ video: { title, description, createdAt, id }, control }) => {
  const [hasQuizTaken, setHasQuizTaken] = useState(false);

  const { id: student_id } = useSelector((state) => state.auth.user);
  const { data: quizMarks, isLoading, isError } = useGetQuizMarksByIdQuery(id);
  const { data: quizzes, isLoading: quizzesReqLoading } =
    useGetQuizzesByVideoIdQuery(id);

  useEffect(() => {
    if (quizMarks && student_id) {
      const quizEligibility = isQuizTaken(student_id, quizMarks);
      if (quizEligibility) {
        return setHasQuizTaken(true);
      } else {
        setHasQuizTaken(false);
      }
    }
  }, [quizMarks, student_id]);

  if (isLoading || quizzesReqLoading) {
    return <div>Laoding...</div>;
  }

  //   Decide which quiz option to show
  let quizButton;

  if (hasQuizTaken) {
    quizButton = (
      <Link
        to={`/lesson/${id}`}
        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
      >
        কুইজে অংশগ্রহণ করেছেন{" "}
      </Link>
    );
  }

  if (!hasQuizTaken && quizzes?.length === 0) {
    quizButton = (
      <Link
        to={`/lesson/${id}`}
        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
      >
        {" "}
        কুইজ নেই{" "}
      </Link>
    );
  }

  if (!hasQuizTaken && quizzes?.length > 0) {
    quizButton = (
      <Link
        to={`/lesson/quiz/${id}`}
        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
      >
        কুইজে অংশগ্রহণ করুন
      </Link>
    );
  }

  return (
    <div>
      <h1 className="text-lg font-semibold tracking-tight text-slate-100">
        {title}
      </h1>
      <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
        Uploaded on {formatDate(createdAt)}
      </h2>

      <div className="flex gap-4">
        <button className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary" onClick={control}>
          এসাইনমেন্ট
        </button>

        {quizButton}
      </div>
      <p className="mt-4 text-sm text-slate-400 leading-6">{description}</p>
    </div>
  );
};

export default Description;
